var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.863 171.26C174.52 157.787 184.399 126.065 170.927 100.407C157.454 74.7485 125.732 64.87 100.074 78.3426C74.4161 91.8151 64.5377 123.537 78.0102 149.194C91.4826 174.853 123.204 184.731 148.863 171.26Z",
    stroke: "#D91966",
    strokeWidth: 2.36967,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.622 170.107C203.643 140.197 199.679 95.6655 169.768 70.6449C139.857 45.6244 95.3262 49.5887 70.3056 79.4996C45.2851 109.41 49.2494 153.941 79.1603 178.962C109.071 203.982 153.602 200.018 178.622 170.107Z",
    stroke: "#D91966",
    strokeWidth: 2.36967,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.076 179.284C123.031 195.06 85.7537 183.451 69.9777 153.406C54.2018 123.361 65.8104 86.0838 95.8554 70.3078C125.9 54.5319 163.178 66.1404 178.954 96.1855C194.73 126.231 183.116 163.511 153.076 179.284Z",
    stroke: "#D91966",
    strokeWidth: 2.36967,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.863 171.26C174.52 157.787 184.399 126.065 170.927 100.407C157.454 74.7485 125.732 64.87 100.074 78.3426C74.4161 91.8151 64.5377 123.537 78.0102 149.194C91.4826 174.853 123.204 184.731 148.863 171.26Z",
    stroke: "#D91966",
    strokeWidth: 2.36967,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.339 162.643C165.238 151.67 173.284 125.832 162.31 104.932C151.336 84.0333 125.499 75.9871 104.599 86.9608C83.7001 97.9344 75.6539 123.773 86.6276 144.672C97.6012 165.571 123.44 173.617 144.339 162.643Z",
    stroke: "#D91966",
    strokeWidth: 2.36967,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.194 154.75C156.735 146.065 163.102 125.617 154.418 109.077C145.733 92.5372 125.284 86.1693 108.744 94.854C92.2044 103.539 85.8365 123.987 94.5212 140.527C103.206 157.068 123.654 163.435 140.194 154.75Z",
    stroke: "#D91966",
    strokeWidth: 2.36967,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro1);
export default __webpack_public_path__ + "static/media/pro1.b42b4322d376116374d3e136a84bf86d.svg";
export { ForwardRef as ReactComponent };